import { render, staticRenderFns } from "./not-permissions.view.vue?vue&type=template&id=e75be67e&scoped=true&"
import script from "./not-permissions.view.ts?vue&type=script&lang=ts&"
export * from "./not-permissions.view.ts?vue&type=script&lang=ts&"
import style0 from "./not-permissions.view.scss?vue&type=style&index=0&id=e75be67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75be67e",
  null
  
)

export default component.exports